import { CommonModule } from '@angular/common';
import { Component, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';

export const MODULES = [
  CommonModule,
  MatCardModule,
  MatIconModule,
  MatButtonModule,
  MatTabsModule,
];
export const COMPONENTS = [FaIconComponent];

@Component({
  selector: 'app-pigeons-legend',
  templateUrl: './pigeons-legend.component.html',
  styleUrls: [
    './pigeons-legend.component.scss',
    '../pigeons-matrix.component.scss',
  ],
  imports: [...MODULES, ...COMPONENTS],
})
export class PigeonsLegendComponent {
  scrollToTop = output();

  onClickScrollToTop(): void {
    this.scrollToTop.emit();
  }
}
